var _hyphenateStyleName=require('hyphenate-style-name');var _hyphenateStyleName2=_interopRequireDefault(_hyphenateStyleName);
var _mapKeyValue=require('../../modules/mapKeyValue');var _mapKeyValue2=_interopRequireDefault(_mapKeyValue);
var _normalizeValue=require('./normalizeValue');var _normalizeValue2=_interopRequireDefault(_normalizeValue);
var _prefixStyles=require('../../modules/prefixStyles');var _prefixStyles2=_interopRequireDefault(_prefixStyles);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var createDeclarationString=function createDeclarationString(prop,val){
var name=(0,_hyphenateStyleName2.default)(prop);
var value=(0,_normalizeValue2.default)(prop,val);
if(Array.isArray(val)){
return val.map(function(v){return name+':'+v;}).join(';');
}
return name+':'+value;
};







var generateCss=function generateCss(style){return(
(0,_mapKeyValue2.default)((0,_prefixStyles2.default)(style),createDeclarationString).sort().join(';'));};

module.exports=generateCss;


// WEBPACK FOOTER //
// ./~/react-native-web/dist/apis/StyleSheet/generateCss.js